import { createRouter, RouterProvider } from '@tanstack/react-router'
import { HelmetProvider } from '@saas-pages/shared/public/seo'
import { initMetrika, renderUtilityApp, trackUtilityRouteChanges } from '@saas-pages/shared/public/runtime'
import branding from '../branding.config'
import { routeTree } from '@/app/routeTree'
import { I18nProvider } from './shared/i18n'
import './styles/index.css'

initMetrika(branding.metrikaId)

const router = createRouter({ routeTree })

trackUtilityRouteChanges(router)

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

renderUtilityApp({
  app: (
    <HelmetProvider>
      <I18nProvider>
        <RouterProvider router={router} />
      </I18nProvider>
    </HelmetProvider>
  ),
})
